import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/GridContainer.js";
import GridItem from "components/GridItem.js";
import CustomInput from "components/CustomInput.js";
import Button from "components/Button.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/workStyle.js";
import emailjs from 'emailjs-com';

const useStyles = makeStyles(styles);

export default function WorkSection() {
  const classes = useStyles();

  const handleSubmit = e => {
    e.preventDefault()
    const { name, email, message } = e.target
    const templateParams = {
      from_name: name.value,
      from_email: email.value,
      message: message.value,
      contact_number: Math.random() * 100000 | 0
    }
    // console.log(templateParams)
    emailjs.send('pbwebsite_gmail', 'pb_contact_form', templateParams, 'user_S3ZTzeJOXP9FuircjCF3g')
      .then(() => {
        alert("Message was successfully sent!")
      }, (error) => {
        alert("Error: " + error.text)
      })
    e.target.reset()
  }

  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem cs={12} sm={12} md={8}>
          <h2 className={classes.title}>Contact Me</h2>
          <h4 className={classes.description}>
            Please do not hesitste to contact me for any
            questions or propositions. 
            I will responde back as soon as possible.
          </h4>
          <form onSubmit={handleSubmit}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <CustomInput
                  labelText="Your Name"
                  id="name"
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <CustomInput
                  labelText="Your Email"
                  id="email"
                  formControlProps={{
                    fullWidth: true
                  }}
                />
              </GridItem>
              <CustomInput
                labelText="Your Message"
                id="message"
                formControlProps={{
                  fullWidth: true,
                  className: classes.textArea
                }}
                inputProps={{
                  multiline: true,
                  rows: 5
                }}
              />
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={4} className={classes.textCenter}>
                  <Button type="submit" color="primary">Send Message</Button>
                </GridItem>
              </GridContainer>
            </GridContainer>
          </form>
        </GridItem>
      </GridContainer>
    </div>
  );
}
